import { render, staticRenderFns } from "./IcoQrFrame.vue?vue&type=template&id=09908ff5"
import script from "./IcoQrFrame.vue?vue&type=script&lang=js"
export * from "./IcoQrFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports